/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { FlagType } from './FlagType.js';
import {
    FlagTypeFromJSON,
    FlagTypeFromJSONTyped,
    FlagTypeToJSON,
} from './FlagType.js';

/**
 * 
 * @export
 * @interface Flag
 */
export interface Flag {
    /**
     * 
     * @type {number}
     * @memberof Flag
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Flag
     */
    name?: string;
    /**
     * 
     * @type {FlagType}
     * @memberof Flag
     */
    type?: FlagType;
}

/**
 * Check if a given object implements the Flag interface.
 */
export function instanceOfFlag(value: object): boolean {
    return true;
}

export function FlagFromJSON(json: any): Flag {
    return FlagFromJSONTyped(json, false);
}

export function FlagFromJSONTyped(json: any, ignoreDiscriminator: boolean): Flag {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'type': json['type'] == null ? undefined : FlagTypeFromJSON(json['type']),
    };
}

export function FlagToJSON(value?: Flag | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'type': FlagTypeToJSON(value['type']),
    };
}

